import { render } from "./EmBreve.vue?vue&type=template&id=425da0d2"
import script from "./EmBreve.vue?vue&type=script&lang=js"
export * from "./EmBreve.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__